<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <div class="border rounded p-1">
          <div class="small text-muted mb-1">同花顺热股</div>
          <iframe class="cmp-frame" src="https://eq.10jqka.com.cn/frontend/thsTopRank"></iframe>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <div class="border rounded p-1">
          <div class="small text-muted mb-1">通达信热度榜</div>
          <iframe class="cmp-frame" src="https://pul.tdx.com.cn/site/app/gzhbd/tdx-topsearch/page-main.html"></iframe>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <div class="border rounded p-1">
          <div class="small text-muted mb-1">东方财富热榜</div>
          <iframe class="cmp-frame" src="https://vipmoney.eastmoney.com/collect/app_ranking/ranking/app.html#/stock"></iframe>
        </div>
      </div>
      
      <div class="col-12 col-sm-6 col-md-3 mb-3">
        <div class="border rounded p-1">
          <div class="small text-muted mb-1">雪球热股</div>
          <iframe class="cmp-frame" src="https://xueqiu.com/hot/stock"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'SentimentPopularCompare' }
</script>

<style scoped>
.cmp-frame{ width:100%; height:1024px; border:none; }
</style>
